import { Txt } from '@vst/beam';
import { Trans, useTranslation } from 'react-i18next';

const ResidentialContent = () => {
  const { t } = useTranslation('ChangePlan', {
    keyPrefix: 'orderReview.details.terms.modal',
  });

  return (
    <>
      <Txt component="p" variant="tinyRegular">
        {t('content.intro1')}
      </Txt>
      <Txt component="p" variant="tinyRegular">
        <Trans ns="ChangePlan" i18nKey="orderReview.details.terms.modal.content.intro2" />
      </Txt>

      <Txt component="p" variant="tinyBold">
        {t('content.servicePlansWithModem.title')}
      </Txt>
      <Txt component="p" variant="tinyRegular">
        {t('content.servicePlansWithModem.intro')}
      </Txt>
      <ol>
        {Object.values(
          t('content.servicePlansWithModem.list', {
            returnObjects: true,
          })
        ).map((key: string, index: number) => (
          <li key={index} style={{ fontSize: 12 }}>
            <Txt component="p" variant="tinyRegular">
              {key}
            </Txt>
          </li>
        ))}
      </ol>
      <Txt component="p" variant="tinyRegular">
        {t('content.servicePlansWithModem.remainingTerms')}
      </Txt>

      <Txt component="p" variant="tinyBold">
        {t('content.anyToUnleashed.title')}
      </Txt>
      <ul>
        {(t('content.anyToUnleashed.list', { returnObjects: true }) as string[]).map((_key: string, index: number) => (
          <li key={index}>
            <Txt component="p" variant="tinyRegular">
              <Trans
                ns="ChangePlan"
                i18nKey={`orderReview.details.terms.modal.content.anyToUnleashed.list.${index}`}
                components={{
                  legalLink: <a href="https://www.viasat.com/legal" target="_blank" rel="noopener noreferrer" />,
                }}
              />
            </Txt>
          </li>
        ))}
      </ul>

      <Txt component="p" variant="tinyBold">
        {t('content.anyToEssentials.title')}
      </Txt>
      <Txt component="p" variant="tinyRegular">
        {t('content.anyToEssentials.intro')}
      </Txt>
    </>
  );
};

export default ResidentialContent;
